export const NOT_SENT_STATUS = "not_sent";
export const SENT_CONTRATANTE_STATUS = "sent_contratante";
export const SENT_PRESTADOR_STATUS = "sent_prestador";

export const STATUS_LABEL = {
	success: "SUCESSO",
	failed: "FALHA",
	skipped: "NÃO ENVIADO",
	[NOT_SENT_STATUS]: "NÃO ENVIADO",
	[SENT_CONTRATANTE_STATUS]: "ENVIADO CONTRATANTES",
	[SENT_PRESTADOR_STATUS]: "ENVIADO PRESTADORES"
};

export const STATUS_COLOR = {
	success: "success",
	failed: "danger",
	skipped: "secondary",
	[NOT_SENT_STATUS]: "secondary",
	[SENT_CONTRATANTE_STATUS]: "warning",
	[SENT_PRESTADOR_STATUS]: "info"
};
